<template>
  <svg
    :class="['w-5 h-5 text-gray-500', className] | twMerge"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9474 10.8C16.7504 10.8 15.5802 11.1519 14.5848 11.8112C13.5895 12.4705 12.8137 13.4075 12.3556 14.5039C11.8975 15.6003 11.7777 16.8067 12.0112 17.9705C12.2447 19.1344 12.8212 20.2035 13.6676 21.0426C14.5141 21.8818 15.5926 22.4532 16.7667 22.6847C17.9407 22.9162 19.1577 22.7974 20.2637 22.3433C21.3696 21.8892 22.3149 21.1201 22.98 20.1334C23.645 19.1467 24 17.9867 24 16.8C24 15.2087 23.3623 13.6826 22.2272 12.5574C21.0922 11.4321 19.5527 10.8 17.9474 10.8ZM20.3685 18H19.158V19.2C19.158 19.5183 19.0304 19.8235 18.8034 20.0485C18.5764 20.2736 18.2685 20.4 17.9474 20.4C17.6264 20.4 17.3185 20.2736 17.0915 20.0485C16.8645 19.8235 16.7369 19.5183 16.7369 19.2V18H15.5264C15.2054 18 14.8975 17.8736 14.6705 17.6485C14.4435 17.4235 14.3159 17.1183 14.3159 16.8C14.3159 16.4817 14.4435 16.1765 14.6705 15.9515C14.8975 15.7264 15.2054 15.6 15.5264 15.6H16.7369V14.4C16.7369 14.0817 16.8645 13.7765 17.0915 13.5515C17.3185 13.3264 17.6264 13.2 17.9474 13.2C18.2685 13.2 18.5764 13.3264 18.8034 13.5515C19.0304 13.7765 19.158 14.0817 19.158 14.4V15.6H20.3685C20.6895 15.6 20.9974 15.7264 21.2244 15.9515C21.4514 16.1765 21.579 16.4817 21.579 16.8C21.579 17.1183 21.4514 17.4235 21.2244 17.6485C20.9974 17.8736 20.6895 18 20.3685 18Z"
      :fill="color"
    />
    <path
      d="M7.05286 6V0.156C6.46217 0.317975 5.92327 0.627435 5.48766 1.0548L2.06434 4.4484C1.63323 4.88022 1.32106 5.41444 1.15767 6H7.05286Z"
      :fill="color"
    />
    <path
      d="M18.0286 0H9.47388V6C9.47388 6.63652 9.2188 7.24697 8.76477 7.69706C8.31075 8.14714 7.69495 8.4 7.05286 8.4H1.0003V21.6C0.99026 22.2257 1.23098 22.8297 1.66965 23.2796C2.10832 23.7296 2.70911 23.9886 3.34022 24H13.6053C11.8365 22.9499 10.5152 21.2958 9.88945 19.3484C9.26369 17.4009 9.37651 15.294 10.2067 13.4232C11.037 11.5523 12.5275 10.0462 14.3985 9.18763C16.2695 8.32903 18.3924 8.17697 20.3685 8.76V2.4C20.3785 1.77435 20.1378 1.17029 19.6991 0.720359C19.2605 0.270426 18.6597 0.0113613 18.0286 0Z"
      :fill="color"
    />
  </svg>

</template>

<script>
export default {
  name: 'FileCirlclePlusFilled',
  props: {
    className: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: 'currentColor'
    }
  }
}
</script>
